import request from '@/utils/request'

//  地址编辑
export function addressEdit (data) {
    return request({
        url: 'product/address/edit',
        method: 'post',
        data: data,
    })
}
//  地址创建
export function addressCreate (data) {
    return request({
        url: 'product/address/create',
        method: 'post',
        data: data,
    })
}
// 地址详情
export function addressDetail (data) {
    return request({
        url: 'product/address/detail',
        method: 'post',
        data: data,
    })
}
// 地址列表
export function addressList (data) {
    return request({
        url: 'product/address/list',
        method: 'post',
        data: data,
    })
}


// 获取省市区
export function getTreeList (data) {
    return request({
        url: 'config/get_tree',
        method: 'post',
        data: data,
    })
}


